/* OH MY JELLY — cart controller. No automatic merchandise mutations. */
(function () {
  'use strict';
  if (window.OmjCart) return;
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency', currency: currency}).format(cents / 100);
  let currency = 'EUR';
  let snapshot = '';
  let busy = false;
  let reading = null;
  let readAgain = false;
  const controls = new Map();
  const routes = window.routes;
  function setBusy(value) {
    busy = value;
    $('#CartDrawer')?.setAttribute('aria-busy', String(value));
    const checkout = $('#CartDrawerFoot a');
    if (checkout) checkout.setAttribute('aria-disabled', String(value));
    if (value) {
      $$('[data-line-change], [data-jelly-add], [data-upsell-add], [data-bdl-cta], form[data-product-form] [type="submit"]').forEach(b => {
        if (!controls.has(b)) controls.set(b, b.disabled); b.disabled = true;
      });
    } else {
      controls.forEach((disabled, b) => { if (b.isConnected) b.disabled = disabled; });
      controls.clear();
    }
  }
  async function request(url, options = {}) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url, {...options, signal:controller.signal, headers:{Accept:'application/json', ...options.headers}});
      if (!response.ok) throw new Error('Shopify request failed');
      return await response.json();
    } finally { clearTimeout(timeout); }
  }
  function commit(cart) {
    if (!Array.isArray(cart.items) || !Number.isFinite(cart.item_count)) throw new Error('Invalid cart');
    currency = cart.currency || currency;
    const next = JSON.stringify(cart);
    if (next === snapshot) return;
    snapshot = next;
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    renderCartDrawer(cart);
    renderGoals(cart);
    renderSubscription(cart);
    dropEarlyGift(cart);
    syncKit(cart);
    // Rendering creates new controls; keep them blocked until the current operation ends.
    if (busy) setBusy(true);
  }
  function refresh() {
    if (busy) { readAgain = true; return Promise.resolve(); }
    if (reading) { readAgain = true; return reading; }
    reading = (async () => {
      // At most one trailing read per cycle. Bursts cannot create an unbounded queue.
      readAgain = false;
      commit(await request(routes.cart_url + '.js'));
      if (readAgain && !busy) { readAgain = false; commit(await request(routes.cart_url + '.js')); }
    })().finally(() => { reading = null; });
    return reading;
  }
  async function mutate(url, payload, open) {
    if (busy) return false;
    setBusy(true);
    const error = $('[data-cart-error]');
    if (error) error.hidden = true;
    try {
      // Finish any older read before sending a write, so stale results cannot overwrite it.
      if (reading) await reading.catch(() => {});
      const data = await request(url, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload)});
      if (Number.isFinite(data.item_count)) commit(data);
      else commit(await request(routes.cart_url + '.js'));
      if (open) $('#CartDrawer')?._open?.();
      return true;
    } catch (_) {
      showCartError();
      // Never retry POST: a lost response does not mean the addition failed.
      return false;
    } finally {
      setBusy(false);
      if (readAgain) { readAgain = false; refresh().catch(showCartError); }
    }
  }
  function add(items, open = true) {
    if (!Array.isArray(items) || !items.length || items.some(i => !Number.isSafeInteger(Number(i.id)) || Number(i.id) <= 0 || !Number.isSafeInteger(i.quantity) || i.quantity < 1)) {
      showCartError(); return Promise.resolve(false);
    }
    return mutate(routes.cart_add_url + '.js', {items}, open).then(ok => {
      if (ok) setTimeout(() => nudgeGift().catch(() => {}), 2500);
      return ok;
    });
  }
  // Wi BOGO+ sometimes misses an add and only adds the free kit (3 pots) on the
  // next cart change. If the kit is still missing, send one no-op change on a
  // pot line so the app checks the cart again. Once per add, never loops.
  const KIT_MIN_POTS = 3;
  async function nudgeGift() {
    let ids = [];
    try { ids = JSON.parse(document.getElementById('OmjEligibleProducts')?.textContent || '[]').map(String); } catch (_) { return; }
    const giftId = String(document.getElementById('CartDrawer')?.dataset.giftProductId || '');
    if (!giftId || busy) return;
    const cart = await request(routes.cart_url + '.js');
    if (cart.items.some(item => String(item.product_id) === giftId)) return;
    if (countEligiblePots(cart.items, ids, giftId) < KIT_MIN_POTS) return;
    const line = cart.items.find(item => ids.includes(String(item.product_id)) && String(item.product_id) !== giftId && !item.selling_plan_allocation);
    if (!line) return;
    await request(routes.cart_change_url + '.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:line.key, quantity:line.quantity})});
    setTimeout(() => refresh().catch(() => {}), 3000);
  }
  window.OmjCart = Object.freeze({add, refresh});
  // Kit au choix : le kit est géré par la buy box et syncKit. On masque l'encadré
  // « Available offers » de Wi BOGO+ (en anglais) dans le panier.
  document.head.insertAdjacentHTML('beforeend', '<style>#CartDrawer .w-cdgo-stack{display:none!important}</style>');
  // Some apps (Wi BOGO+, BON Loyalty…) show Shopify's raw cart error text, e.g.
  // « Le paramètre updates n'est pas… », to shoppers. Hide those technical messages.
  const RAW_ERROR = /param[eè]tre\s+(updates|items|id|quantity)|parameter\s+(updates|items)|Cart Error|Cannot find variant/i;
  new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1 || !RAW_ERROR.test(node.textContent || '')) continue;
        if ((node.textContent || '').length > 300 || node.closest('#CartDrawer, main')) continue;
        node.remove();
      }
    }
  }).observe(document.body, {childList:true, subtree:true});
  // Single explicit adapter for BOGO+. No fetch interception, polling or synthetic clicks.
  window.omjRefreshGiftCart = () => refresh().catch(showCartError);
  if (!window._wizzCustomCartScript) window._wizzCustomCartScript = 'window.omjRefreshGiftCart();';
  document.addEventListener('cart:updated', () => refresh().catch(showCartError));
  document.addEventListener('click', event => {
    if (busy && event.target.closest('#CartDrawerFoot a')) { event.preventDefault(); return; }
    const button = event.target.closest('button, [data-cart-open]');
    if (!button) return;
    if (button.matches('[data-cart-open]')) { refresh().catch(showCartError); return; }
    if (button.disabled || busy) return;
    if (button.matches('[data-line-change]')) {
      event.preventDefault();
      mutate(routes.cart_change_url + '.js', {id:button.dataset.lineChange, quantity:Number(button.dataset.qty)}, false);
    } else if (button.matches('[data-jelly-add], [data-upsell-add]')) {
      event.preventDefault();
      add([{id:Number(button.dataset.jellyAdd || button.closest('[data-cart-upsell]')?.dataset.variantId), quantity:1}], false);
    } else if (button.matches('[data-bdl-cta]')) {
      event.preventDefault();
      const bundle = document.getElementById(button.dataset.bdlTarget);
      if (!bundle?.getCartItems) { showCartError(); return; }
      const items = bundle.getCartItems();
      if (items) add(items);
    }
  });
  // Abonnement : la case en bas du panier ajoute / retire le plan Kaching sur la ligne du pot.
  document.addEventListener('change', event => {
    const box = event.target.closest('[data-cart-sub-toggle]');
    if (!box) return;
    if (busy || !box.dataset.line) { box.checked = !box.checked; return; }
    mutate(routes.cart_change_url + '.js', {id:box.dataset.line, quantity:1, selling_plan: box.checked ? Number(box.dataset.plan) : null}, false);
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('form[data-product-form]');
    if (!form) return;
    event.preventDefault();
    if (busy) return;
    const bundle = document.getElementById(form.dataset.bdlTarget);
    // The new bundle path is never used as an app's synthetic form submission target.
    if (form.querySelector('[data-original-name]')) { showCartError(); return; }
    if (bundle) {
      if (!bundle.getCartItems) { showCartError(); return; }
      const items = bundle.getCartItems();
      if (items) add(items);
    } else {
      const values = new FormData(form);
      const properties = {};
      for (const [key,value] of values) if (/^properties\[.+\]$/.test(key)) properties[key.slice(11,-1)] = value;
      const item = {id:Number(values.get('id')), quantity:Number(values.get('quantity') || 1), properties};
      if (values.get('selling_plan')) item.selling_plan = values.get('selling_plan');
      add([item]);
    }
  });
  const media = window.matchMedia('(max-width: 640px)');
  function placeRecommendations() {
    const drawer = $('#CartDrawer');
    const recommendations = $('.omj-recommendations');
    const parent = drawer && $(media.matches ? '.omj-cart-scroll' : '.omj-panel', drawer);
    if (parent && recommendations && recommendations.parentElement !== parent) parent.appendChild(recommendations);
  }
  media.addEventListener('change', placeRecommendations);
  placeRecommendations();
  // One continuous fill; stop at the first incomplete milestone.
  function goalProgress(states) {
    if (!states.length) return 0;
    const index = states.findIndex(state => state.remaining > 0);
    if (index < 0) return 100;
    const current = states[index];
    const previous = states[index - 1];
    const railUnits = states.length - 0.5;
    const start = index ? (index - 0.5) / railUnits : 0;
    const end = (index + 0.5) / railUnits;
    const baseline = previous && previous.metric === current.metric && previous.target < current.target ? previous.target : 0;
    const fraction = Math.max(0, Math.min(1, (current.value - baseline) / (current.target - baseline)));
    return (start + (end - start) * fraction) * 100;
  }

  function countEligiblePots(items, eligibleIds, giftId) {
    return items.reduce((sum, item) => sum + (
      String(item.product_id) !== String(giftId) &&
      eligibleIds.includes(String(item.product_id))
        ? Number(item.quantity) : 0
    ), 0);
  }

  function showCartError() {
    const error = $('[data-cart-error]');
    if (error) {
      error.textContent = 'Le panier n’a pas pu être actualisé. Vérifie son contenu avant de réessayer.';
      error.hidden = false;
    }
    const drawer = document.getElementById('CartDrawer');
    if (drawer && drawer._open) drawer._open();
  }


  function renderGoals(cart) {
    const data = document.getElementById('OmjEligibleProducts');
    let ids = [];
    try { ids = JSON.parse(data?.textContent || '[]').map(String); } catch (_) { return; }
    const drawer = document.getElementById('CartDrawer');
    const giftId = drawer?.dataset.giftProductId || '8302695186737';
    const quantity = countEligiblePots(cart.items, ids, giftId);
    // Un pack « Composer mon pack » (Easy Bundle Builder) a déjà ses offres : ses pots ne
    // s'additionnent pas aux pots seuls pour Wi BOGO+. On masque alors les objectifs en pots.
    const hasPack = cart.items.some(item => item.properties && '_EasyBundleId' in item.properties);
    const rail = $('[data-goals-rail]');
    if (rail) rail.style.display = hasPack ? 'none' : '';
    const states = [];
    $$('[data-goal]').forEach((goal) => {
      const amount = goal.dataset.metric === 'amount';
      goal.style.display = hasPack && !amount ? 'none' : '';
      if (hasPack && !amount) return;
      const target = Number(goal.dataset.threshold) * (amount ? 100 : 1);
      if (!(target > 0)) return;
      const value = amount ? cart.total_price : quantity;
      const remaining = Math.max(0, target - value);
      const percent = Math.min(100, Math.max(0, value / target * 100));
      goal.classList.toggle('is-reached', remaining === 0);
      const status = $('[data-goal-status]', goal);
      status.textContent = remaining === 0
        ? (amount ? 'Seuil atteint ✓' : 'Sélection complète ✓')
        : (amount ? 'Encore ' + formatMoney(remaining).replace(/<[^>]*>/g, '') : 'Ajoute encore ' + remaining + (remaining > 1 ? ' pots' : ' pot'));
      states.push({ goal, remaining, value, target, metric: goal.dataset.metric, text: status.textContent });
    });
    if (rail && !hasPack) {
      const progress = goalProgress(states);
      rail.style.setProperty('--goal-progress', progress + '%');
      rail.setAttribute('aria-valuenow', String(Math.round(progress)));
    }
    const next = states.find((state) => state.remaining > 0);
    const message = $('[data-goals-message]');
    if (message) message.textContent = next
        ? next.text + ' · ' + $('strong', next.goal).textContent
        : 'Tous les paliers de sélection sont atteints';
  }

  // Wi BOGO+ sometimes adds the free kit (line property « _BOGO+ ») when only 2 pots
  // are in the cart; Shopify then charges it 15,90 € because the discount needs 3.
  // Remove that gift line while the cart has fewer than KIT_MIN_POTS pots.
  // A kit added by the shopper (upsell button) has no « _BOGO+ » property and stays.
  let droppingGift = false;
  function dropEarlyGift(cart) {
    if (droppingGift || busy) return;
    let ids = [];
    try { ids = JSON.parse($('#OmjEligibleProducts')?.textContent || '[]').map(String); } catch (_) { return; }
    const giftId = String($('#CartDrawer')?.dataset.giftProductId || '');
    const gift = cart.items.find(item => String(item.product_id) === giftId && item.properties && '_BOGO+' in item.properties);
    if (!gift || countEligiblePots(cart.items, ids, giftId) >= KIT_MIN_POTS) return;
    droppingGift = true;
    setTimeout(() => {
      mutate(routes.cart_change_url + '.js', {id:gift.key, quantity:0}, false).finally(() => { droppingGift = false; });
    }, 1500);
  }

  // Kit d'application au choix (attribut de panier « omj_kit » posé par la buy box).
  // « non » : on retire le kit. Sinon, dès 3 pots (abonnement compris), on l'ajoute
  // avec la propriété _BOGO+ pour que la réduction KITOFFERT le passe à 0 €.
  let kitBusy = false, kitVariant = 0;
  async function syncKit(cart) {
    if (kitBusy || busy) return;
    let ids = [];
    try { ids = JSON.parse($('#OmjEligibleProducts')?.textContent || '[]').map(String); } catch (_) { return; }
    const giftId = String($('#CartDrawer')?.dataset.giftProductId || '');
    if (!giftId) return;
    const kits = cart.items.filter(item => String(item.product_id) === giftId);
    const pots = cart.items.filter(item => ids.includes(String(item.product_id)) && String(item.product_id) !== giftId);
    const count = pots.reduce((sum, item) => sum + Number(item.quantity), 0);
    /* Choix fait sur cette page (immédiat) sinon celui gardé dans le panier. */
    const wanted = (window.OmjKitChoice || (cart.attributes || {}).omj_kit) !== 'non';
    kitBusy = true;
    try {
      if (!wanted && kits.length) {
        await request(routes.cart_update_url + '.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({updates:Object.fromEntries(kits.map(k => [k.key, 0]))})});
        setTimeout(() => refresh().catch(() => {}), 500);
      } else if (wanted && count >= KIT_MIN_POTS && !kits.length && pots.length) {
        if (!kitVariant) kitVariant = (await request('/products/accessoires-kit-application.js')).variants[0].id;
        await request(routes.cart_add_url + '.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:kitVariant, quantity:1, properties:{'_BOGO+':'39351_' + pots[0].variant_id}}]})});
        setTimeout(() => refresh().catch(() => {}), 500);
      }
    } catch (_) {} finally { setTimeout(() => { kitBusy = false; }, 4000); }
  }

  function renderSubscription(cart) {
    const wrap = $('[data-cart-sub]');
    if (!wrap) return;
    let plans = {}, ids = [];
    try {
      plans = JSON.parse($('#OmjSubPlans')?.textContent || '{}');
      ids = JSON.parse($('#OmjEligibleProducts')?.textContent || '[]').map(String);
    } catch (_) { wrap.hidden = true; return; }
    // Tous les pots, abonnés ou non : l'offre n'a de sens qu'avec 1 seul pot.
    const giftId = String($('#CartDrawer')?.dataset.giftProductId || '');
    const pots = cart.items.filter(item => ids.includes(String(item.product_id)) && String(item.product_id) !== giftId);
    const units = pots.reduce((sum, item) => sum + Number(item.quantity), 0);
    const line = units === 1 ? pots[0] : null;
    const plan = line && plans[String(line.product_id)];
    if (!plan) { wrap.hidden = true; return; }
    const box = $('[data-cart-sub-toggle]', wrap);
    box.checked = Boolean(line.selling_plan_allocation);
    box.dataset.line = line.key;
    box.dataset.plan = plan.plan;
    $('[data-cart-sub-title]', wrap).textContent = 'Passe en abonnement' + (plan.pct ? ' et économise ' + plan.pct + ' %' : '');
    $('[data-cart-sub-note]', wrap).textContent = formatMoney(plan.price) + ' au lieu de ' + formatMoney(plan.compare) + ' · ' + plan.name + ' · Garantie 60 jours · Sans engagement';
    wrap.hidden = false;
  }

  function renderCartDrawer(cart) {
    const drawer = $('#CartDrawer');
    const list = $('#CartDrawerItems');
    const foot = $('#CartDrawerFoot');
    if (!drawer || !list) return;

    const countEl = $('[data-drawer-count]', drawer);
    if (countEl) countEl.textContent = `${cart.item_count} article${cart.item_count > 1 ? 's' : ''}`;

    const shippingThreshold = parseInt(drawer.dataset.shippingThreshold || '0', 10);
    const shippingCopy = $('[data-shipping-copy]', drawer);
    const shippingFill = $('[data-shipping-fill]', drawer);
    const shippingBox = $('[data-shipping-box]', drawer);
    if (shippingBox) {
      if (shippingThreshold > 0 && cart.item_count > 0) {
        shippingBox.hidden = false;
        const remaining = Math.max(0, shippingThreshold - cart.total_price);
        const progress = Math.min(100, (cart.total_price / shippingThreshold) * 100);
        if (shippingFill) shippingFill.style.width = `${progress}%`;
        if (shippingCopy) {
          const progressText = drawer.dataset.shippingProgressText || 'Plus que [montant] pour la livraison offerte';
          const unlockedText = drawer.dataset.shippingUnlockedText || 'Livraison offerte débloquée ✨';
          shippingCopy.innerHTML = remaining > 0
            ? progressText.replace('[montant]', `<strong>${formatMoney(remaining)}</strong>`)
            : `<strong>${unlockedText}</strong>`;
        }
        shippingBox.classList.toggle('is-complete', remaining === 0);
      } else {
        shippingBox.hidden = true;
      }
    }

    const extras = $('[data-cart-extras]', drawer);
    if (extras) extras.hidden = cart.item_count === 0;
    const ebook = $('[data-cart-ebook]', drawer);
    if (ebook) {
      let ebookIds = [];
      try { ebookIds = JSON.parse(document.getElementById('OmjEligibleProducts')?.textContent || '[]').map(String); } catch (_) {}
      const pots = countEligiblePots(cart.items, ebookIds, String(drawer.dataset.giftProductId || ''));
      ebook.hidden = pots < Number(ebook.dataset.minPots || 3);
    }
    if (cart.item_count === 0) {
      const emptyTitle = list.dataset.emptyTitle || 'Ton panier est vide';
      const emptyText = list.dataset.emptyText || '';
      const emptyButton = list.dataset.emptyButton || 'Découvrir les Jellys';
      const emptyLink = list.dataset.emptyLink || '/collections/all';
      list.innerHTML = `<div class="cart-drawer__empty"><strong>${escapeHTML(emptyTitle)}</strong><p>${escapeHTML(emptyText)}</p><a href="${escapeHTML(emptyLink)}" class="btn btn--solid">${escapeHTML(emptyButton)}</a></div>`;
      if (foot) foot.hidden = true;
      return;
    }

    if (foot) {
      foot.hidden = false;
      const totalEl = $('[data-cart-total]', foot);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      const reassure = $('[data-cart-reassure]', foot);
      if (reassure && shippingThreshold > 0) {
        reassure.textContent = cart.total_price >= shippingThreshold
          ? '✓ Livraison offerte · Paiement sécurisé'
          : 'Livraison offerte dès ' + formatMoney(shippingThreshold).replace(/[.,]00/, '') + ' · Paiement sécurisé';
      }

      const upsell = $('[data-cart-upsell]', drawer);
      if (upsell) {
        const upsellProductId = String(upsell.dataset.productId || '');
        const alreadyInCart = cart.items.some((item) => String(item.product_id) === upsellProductId);
        upsell.hidden = alreadyInCart;
      }

      /* « Complète ta routine » : on ne propose pas le kit à 15,90 € s'il est déjà dans le panier. */
      const kitIds = cart.items.filter(item => String(item.product_id) === String(drawer.dataset.giftProductId || '')).map(item => String(item.variant_id));
      $$('.omj-recommendation [data-jelly-add]', drawer).forEach(btn => {
        btn.closest('.omj-recommendation').hidden = kitIds.includes(String(btn.dataset.jellyAdd));
      });
    }

    list.innerHTML = cart.items.map((item) => `
      <div class="cart-drawer__item card">
        <a href="${escapeHTML(item.url)}" class="cart-drawer__item-media">
          <img src="${escapeHTML(item.image || '')}" alt="" width="80" height="96" loading="lazy">
        </a>
        <div class="cart-drawer__item-main">
          <div class="cart-drawer__item-top">
            <a href="${escapeHTML(item.url)}" class="cart-drawer__item-title">${escapeHTML(item.product_title)}</a>
            <button type="button" class="cart-drawer__remove" data-line-change="${escapeHTML(item.key)}" data-qty="0" aria-label="Supprimer ${escapeHTML(item.product_title)}">×</button>
          </div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer__variant">${escapeHTML(item.variant_title)}</div>` : ''}
          ${item.selling_plan_allocation ? `<div class="cart-drawer__variant">Abonnement · ${escapeHTML(item.selling_plan_allocation.selling_plan.name)}</div>` : ''}
          <div class="cart-drawer__item-bottom">
            <div class="qty-input cart-drawer__qty">
              <button type="button" data-line-change="${escapeHTML(item.key)}" data-qty="${Math.max(0, item.quantity - 1)}" aria-label="Retirer une unité">−</button>
              <input type="text" value="${item.quantity}" readonly aria-label="Quantité">
              <button type="button" data-line-change="${escapeHTML(item.key)}" data-qty="${item.quantity + 1}" aria-label="Ajouter une unité">+</button>
            </div>
            <strong class="cart-drawer__item-price">${item.final_line_price === 0 && item.original_line_price > 0 ? '<span class="cart-gift-label">OFFERT 🎁</span>' : formatMoney(item.final_line_price)}</strong>
          </div>
        </div>
      </div>`).join('');

  }

  refresh().catch(showCartError);
})();
